import { render, staticRenderFns } from "./payslipDetail.vue?vue&type=template&id=165d54c2&scoped=true&"
import script from "./payslipDetail.vue?vue&type=script&lang=js&"
export * from "./payslipDetail.vue?vue&type=script&lang=js&"
import style0 from "./payslipDetail.vue?vue&type=style&index=0&id=165d54c2&lang=less&scoped=true&"
import style1 from "./payslipDetail.vue?vue&type=style&index=1&id=165d54c2&lang=less&scoped=true&"
import style2 from "./payslipDetail.vue?vue&type=style&index=2&id=165d54c2&lang=less&scoped=true&"
import style3 from "./payslipDetail.vue?vue&type=style&index=3&id=165d54c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d54c2",
  null
  
)

export default component.exports